import moment from 'shared/lib/moment'
import OperatinRuleUtils from 'shared/utils/operating_rules'

export const isOverdue = (cart) => {
  // If there is no cart (yet) we return.
  if (!cart) return false

  if (!cart.starts_at) return false

  // We get the start date from the cart.
  const startsAt = moment(cart.starts_at)

  // Check if this time is selectable
  return !OperatinRuleUtils.isTimeSelectable(startsAt)
}

export const getLocalCartId = () => {
  return window.booqableOptions?.cart?.id || localStorage.bqCartId
}

export default {
  isOverdue
}
